import { useEffect, useState } from "react";
// import slider1 from "./../assets//img/DitapUnitySlider1.png";
// import slider2 from "./../assets//img/DitapUnitySlider2.png";
// import slider3 from "./../assets//img/DitapUnitySlider3.png";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper/modules";

function Ditapunity({ getData }) {
  useEffect(() => {
    getData(
      "DiTAP for Unity",
      "데스크탑 기반 디지털트윈 가시화를 위한 SDK이며",
      "3차원 행성단위 가시화 디지털트윈 솔루션 입니다."
    );
  }, [getData]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  //스와이프
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<div class="ditap-slider-control-btn ' +
        className +
        '"><p>0' +
        (index + 1) +
        "</p><p class='ditap-slider-bar'></p></div>"
      );
    },
  };

  const [swiper, setSwiper] = useState(null);
  // swiper instance
  const [play, setPlay] = useState(true); // auto play 기준

  useEffect(() => {
    const swiperInstance = document.querySelector(".auto-swiper").swiper;

    setSwiper(swiperInstance);
  }, []);

  useEffect(() => {
    if (typeof swiper === "object") {
      if (play) {
        swiper?.autoplay.start();
      } else {
        swiper?.autoplay.stop();
      }
    }
  }, [swiper, play]);

  const onClickAutoPlayBtn = () => {
    setPlay(!play);
  };

  return (
    <>
      {pc ? (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <div>
                  <h2 className="basic-title">DiTAP for Unity</h2>
                  <div className="basic-subtitle">
                    <p>
                      3D Tiles 가시화 기능, 기본 GIS 기능(거리, 면적계산 등),
                    </p>
                    <p>
                      시계열 데이터 가시화 기능 등 다양한 기능을 제공합니다.
                    </p>
                  </div>
                </div>
                <p className="mark"></p>
              </div>

              <p className="basic-banner ditap-unity-banner"></p>
              <div>
                <ul className="ditap-info-list">
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info1"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">Unity3D 엔진용</span>
                        <span className="basic-block">디지털 트윈 SDK</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          Unity3D 환경에서 OGC 표준을 준수한 사용자 임의
                          디지털트윈 데이터를 가시화하고 편리하게 관리하는 기능
                          제공
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info2"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3차원 행성단위</span>
                        <span className="basic-block">가시화 디지털 트윈</span>
                        <span className="basic-block">솔루션</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          행성단위의 고품질ㆍ대용량 GIS 데이터 가시화 및 렌더링
                          성능 최적화 지원
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info3"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">기본 GIS 기능 제공</span>
                        <span className="basic-block">(거리, 면적계산 등)</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          국제 표준화 기구인 개방형 공간 정보 컨소시엄(Open
                          Geospatial Consortium)의 규격에 맞춰 3D Tiles(대용량
                          3D 모델), gltf, WMS 등을 가시화하여 상호 운용성 보장
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info4"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">시계열 데이터</span>
                        <span className="basic-block">가시화 기능 제공</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          협정 세계시(UTC)를 기준으로한 시계열 데이터 가시화를
                          지원하며 3차원 데이터를 시계열과 동기화하는 기능 제공
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ditap-banner">
              <div className="basic-title">
                <p className="txt">데스크탑 기반 디지털 트윈</p>
                <p className="txt">가시화를 위한 SDK</p>
              </div>
              <p className="basic-banner ditap-unity-banner2"></p>
            </div>
            <div className="ditap-introduce">
              <div className="basic-title">
                <p className="txt">DiTAP for Unity 주요 기능</p>
              </div>
              <div className="ditap-introduce-item">
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box unity-introduce-img1"></div>
                  <div>
                    <h3 className="ditap-introduce-subtitle">
                      행성규모 지구 가시화
                    </h3>
                    <div className="ditap-introduce-cont">
                      <p>
                        공간정보 기반 행성단위 3차원 지구 가시화 기능을
                        지원합니다. 고품질ㆍ대용량 공간정보 데이터를 가시화할 수
                        있으며 최적화 기술을 통해 렌더링 성능을 높였으며, API를
                        통해 누구든지 손쉽게 사용 가능합니다.
                      </p>
                      <p>
                        또한 지도 서비스 기능(거리, 면적 계산 등)을 제공하여
                        다양한 목적을 가진 디지털트윈 기능 확장이 가능합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">
                        3D 오브젝트 관리
                      </h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          평면, 구, 캡슐 등 3차원 오브젝트를 생성하거나 API를
                          통해 OBJ, GLB, GLTF 형식의 모델 데이터를 위/경도 좌표
                          기준으로 지형 공간데이터와 함께 가시화 합니다.
                        </p>
                        <p>
                          생성된 3D 오브젝트의 크기조절, 이동, 회전 등의 변형이
                          가능하며 수정/삭제가 가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ditap-introduce-img-box unity-introduce-img2"></div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box unity-introduce-img3"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">
                        CZML 지원(시간 동적 시각화)
                      </h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          웹 기반 시각화 엔진에서 사용되는 시간 기반 데이터 교환
                          형식인 CZML을 지원합니다.
                        </p>
                        <p>
                          대규모 시공간 데이터를 효율적으로 스트리밍 하고 시각화
                          할 수 있으며 시간에 따른 변화를 다루기 때문에
                          지구과학, 군사, 항공 우주, 교통 분야에서 사용할 수
                          있습니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="ditap-used-wrap">
                <button
                  onClick={onClickAutoPlayBtn}
                  className="ditap-slider-control-btn swiper-stop-control"
                ></button>
                <div className="ditap-used-item">
                  <Swiper
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    pagination={pagination}
                    modules={[Autoplay, Pagination]}
                    className="auto-swiper"
                  >
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              재생에너지 자원 디지털트윈 서비스
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              GIS 정보를 이용한 공간 환경 가시화를 기반으로
                              재생에너지 자원과 연계하여 형상모사/정적/동적/
                              상호작용 디지털트윈 가시화를 실현하는 서비스.
                            </p>
                            <p>
                              구축된 재생에너지 자원 설비들에 대한 디지털트윈
                              관제 운영을 기본으로 태양관패널들의 추가 설치와
                              자유로운 변경 및 향후 기능 확장을 지원하고
                              취득되는 에너지/환경데이터 모니터링 및 예측을
                              지원합니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  한국전기연구원 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img unity-used1"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              부산에코델타시티 스마트빌리지 실감형 3차원 실증
                              서비스
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              3D 도시모델 데이터를 추가,삭제하고 편집한 기록을
                              시간축에서 관리하는 시계열 데이터 관리 기술개발로
                              Unity 기반의 3Dtiles를 가시화하고 도시모델 기반의
                              편집 및 시계열 가시화를 하는 서비스.
                            </p>
                            <p>
                              속성정보, 건물/지형 고도분석, 경관분석 등을
                              제공하고 타부처 연계 데이터 가시화로 확장성 있는
                              서비스를 제공합니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  한국전자통신연구원 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img unity-used2"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              전북지역 도시재생 공원경관 조성 시뮬레이션
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              가상의 공간에 현실 지형을 재현하여 정원을
                              조성해보고 검토할 수 있는 시뮬레이션 시스템.
                            </p>
                            <p>
                              실제 지형에 다양한 식재와 소재 모델들을
                              선택/배치해보고 공원을 조성한 후 그 느낌을 경험해
                              볼 수 있습니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  전북대학교 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img unity-used3"></p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <h2 className="basic-title">DiTAP for Unity</h2>
                <p className="mark"></p>
              </div>
              <div className="basic-subtitle">
                <p>3D Tiles 가시화 기능, 기본 GIS 기능(거리, 면적계산 등),</p>
                <p>시계열 데이터 가시화 기능 등 다양한 기능을 제공합니다.</p>
              </div>
              <p className="basic-banner ditap-unity-banner"></p>
              <div>
                <ul className="ditap-info-list">
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info1"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">Unity3D 엔진용</span>
                        <span className="basic-block">디지털 트윈 SDK</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          Unity3D 환경에서 OGC 표준을 준수한 사용자 임의
                          디지털트윈 데이터를 가시화하고 편리하게 관리하는 기능
                          제공
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info2"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3차원 행성단위</span>
                        <span className="basic-block">가시화 디지털 트윈</span>
                        <span className="basic-block">솔루션</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>행성단위의 고품질ㆍ대용량 GIS 데이터 가시화 및</p>
                        <p>렌더링 성능 최적화 지원</p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info3"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">기본 GIS 기능 제공</span>
                        <span className="basic-block">(거리, 면적계산 등)</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>국제 표준화 기구인 개방형 공간 정보 컨소시엄(Open</p>
                        <p>
                          Geospatial Consortium)의 규격에 맞춰 3D Tiles(대용량
                          3D 모델), gltf, WMS 등을 가시화하여 상호 운용성 보장
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img unity-info4"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">시계열 데이터</span>
                        <span className="basic-block">가시화 기능 제공</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          협정 세계시(UTC)를 기준으로한 시계열 데이터 가시화를
                          지원하며 3차원 데이터를 시계열과 동기화하는 기능 제공
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ditap-banner">
              <div className="basic-title">
                <p className="txt">데스크탑 기반 디지털 트윈</p>
                <p className="txt">가시화를 위한 SDK</p>
              </div>
              <p className="basic-banner ditap-unity-banner2"></p>
            </div>
            <div className="ditap-introduce">
              <div className="basic-title">
                <p className="txt">DiTAP for Unity</p>
                <p className="txt">주요 기능</p>
              </div>
              <div className="ditap-introduce-item">
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box unity-introduce-img1"></div>
                  <div>
                    <h3 className="ditap-introduce-subtitle">
                      행성규모 지구 가시화
                    </h3>
                    <div className="ditap-introduce-cont">
                      <p>
                        공간정보 기반 행성단위 3차원 지구 가시화 기능을
                        지원합니다. 고품질ㆍ대용량 공간정보 데이터를 가시화할 수
                        있으며 최적화 기술을 통해 렌더링 성능을 높였으며, API를
                        통해 누구든지 손쉽게 사용 가능합니다.
                      </p>
                      <p>
                        또한 지도 서비스 기능(거리, 면적 계산 등)을 제공하여
                        다양한 목적을 가진 디지털트윈 기능 확장이 가능합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box unity-introduce-img2"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">
                        3D 오브젝트 관리
                      </h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          평면, 구, 캡슐 등 3차원 오브젝트를 생성하거나 API를
                          통해 OBJ, GLB, GLTF 형식의 모델 데이터를 위/경도 좌표
                          기준으로 지형 공간데이터와 함께 가시화 합니다.
                        </p>
                        <p>
                          생성된 3D 오브젝트의 크기조절, 이동, 회전 등의 변형이
                          가능하며 수정/삭제가 가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box unity-introduce-img3"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">
                        CZML 지원(시간 동적 시각화)
                      </h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          웹 기반 시각화 엔진에서 사용되는 시간 기반 데이터 교환
                          형식인 CZML을 지원합니다.
                        </p>
                        <p>
                          대규모 시공간 데이터를 효율적으로 스트리밍 하고 시각화
                          할 수 있으며 시간에 따른 변화를 다루기 때문에
                          지구과학, 군사, 항공 우주, 교통 분야에서 사용할 수
                          있습니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="ditap-used-wrap">
                <div className="ditap-used-item">
                  <button
                    onClick={onClickAutoPlayBtn}
                    className="ditap-slider-control-btn swiper-stop-control"
                  ></button>
                  <Swiper
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    pagination={pagination}
                    modules={[Autoplay, Pagination]}
                    className="auto-swiper"
                  >
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              재생에너지 자원 디지털트윈 서비스
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              GIS 정보를 이용한 공간 환경 가시화를 기반으로
                              재생에너지 자원과 연계하여 형상모사/정적/동적/
                              상호작용 디지털트윈 가시화를 실현하는 서비스.
                            </p>
                            <p>
                              구축된 재생에너지 자원 설비들에 대한 디지털트윈
                              관제 운영을 기본으로 태양관패널들의 추가 설치와
                              자유로운 변경 및 향후 기능 확장을 지원하고
                              취득되는 에너지/환경데이터 모니터링 및 예측을
                              지원합니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  한국전기연구원 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img unity-used1"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              부산에코델타시티 스마트빌리지 실감형
                            </span>
                            <span className="basic-block">
                              3차원 실증 서비스
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              3D 도시모델 데이터를 추가,삭제하고 편집한 기록을
                              시간축에서 관리하는 시계열 데이터 관리 기술개발로
                              Unity 기반의 3Dtiles를 가시화하고 도시모델 기반의
                              편집 및 시계열 가시화를 하는 서비스.
                            </p>
                            <p>
                              속성정보, 건물/지형 고도분석, 경관분석 등을
                              제공하고 타부처 연계 데이터 가시화로 확장성 있는
                              서비스를 제공합니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  한국전자통신연구원 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img unity-used2"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              전북지역 도시재생 공원경관 조성
                            </span>
                            <span className="basic-block">시뮬레이션</span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              가상의 공간에 현실 지형을 재현하여 정원을
                              조성해보고 검토할 수 있는 시뮬레이션 시스템.
                            </p>
                            <p>
                              실제 지형에 다양한 식재와 소재 모델들을
                              선택/배치해보고 공원을 조성한 후 그 느낌을 경험해
                              볼 수 있습니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  전북대학교 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img unity-used3"></p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Ditapunity;
